<template>
<div>
    <v-toolbar dark flat color="primary">
        <v-toolbar-title>Manually enroll or waitlist students</v-toolbar-title>
    </v-toolbar>

    <v-card>
        <v-card-text>
            <v-layout align-center>
                <v-autocomplete :items="students" :item-text="studentDisplay" v-model="selectedStudent" label="Student" name="student" search-input return-object>
                </v-autocomplete>
                <v-spacer></v-spacer>
                <v-btn color="green" class="white--text" @click="enroll">Add to Course</v-btn>
                <v-btn color="yellow" @click="waitlist">Add to Waitlist</v-btn>
            </v-layout>
        </v-card-text>
    </v-card>

    <v-dialog v-model="alert.active" max-width="500px">
        <v-card>
            <v-card-text>
                <v-alert class="title" :value="true" :type="alert.type">{{ alert.message }}</v-alert>
            </v-card-text>
            <v-card-actions>
                <v-btn flat color="primary" @click="alert.active = false">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
export default {
    props: ['course'],
    data() {
        return {
            selectedStudent: {},
            alert: {
                active: false,
                message: '',
                type: 'success'
            }
        }
    },
    computed: {
        culprit() {
            return this.$store.getters.culprit
        },
        students() {
            return this.$store.state.admin.students
        }
    },
    methods: {
        studentDisplay: item => 'ID: ' + item.id + ' - ' + item.first_name + ' ' + item.last_name,
        enroll() {
            let payload = {
                course_id: this.course.id,
                student_id: this.selectedStudent.id,
                culprit: this.culprit
            }
            this.$store.dispatch('adminEnroll', payload)
                .then(() => {
                    this.alert.message = 'Student succesfully enrolled!'
                    this.alert.type = 'success'
                    this.alert.active = true
                    this.selectedStudent = {}
                })
                .catch((e) => {
                    this.alert.message = e.response.data.message
                    this.alert.type = 'warning'
                    this.alert.active = true
                })
        },
        waitlist() {
            let payload = {
                course_id: this.course.id,
                student_id: this.selectedStudent.id,
                culprit: this.culprit
            }
            this.$store.dispatch('adminWaitlist', payload)
                .then(() => {
                    this.alert.message = 'Student succesfully added to waitlist!'
                    this.alert.type = 'success'
                    this.alert.active = true
                    this.selectedStudent = {}
                })
                .catch((e) => {
                    this.alert.message = e.response.data.message
                    this.alert.type = 'warning'
                    this.alert.active = true
                })
        }
    }
}
</script>
